import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  List,
  ListItem,
  ListItemText
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {},
  listItem: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.background.default
    }
  },
  arrowForwardIcon: {
    color: theme.palette.icon
  }
}));

const Items = props => {
  const { items, className, ...rest } = props;

  const classes = useStyles();

  return (
    <List
      {...rest}
      className={clsx(classes.root, className)}
      disablePadding
    >
      {items.map((item, i) => (
        <ListItem
          button
          className={classes.listItem}
          divider={i < items.length - 1}
          key={i}
          onClick={item.onClick}
        >
          <ListItemText
            primary={item.title}
            primaryTypographyProps={{ variant: 'body1' }}
          // secondary={''}
          />
        </ListItem>
      ))}
    </List>
  );
};

Items.propTypes = {
  className: PropTypes.string,
  items: PropTypes.array.isRequired
};

export default Items;
